module.exports = __webpack_public_path__ + "img/common-file-text-info.1a057d81.svg";